'use strict';
var config = require("./config")

var helper = {
	getUrlKey:function(url){
		var index1=url.lastIndexOf("\/")+1;
		var index2=url.lastIndexOf(".");  
		
		var tag = url.substring(index1,index2);
		return tag
	}
}

module.exports = helper


//////////////////
// WEBPACK FOOTER
// ./src/helper.js
// module id = 1
// module chunks = 0